export const ReviewsOptions = [
  {value: "Facebook", display: "Facebook"},
  {value: "Better Business Bureau (BBB)", display: "Better Business Bureau (BBB)"},
  {value: "Certified Consumer Reviews (CCR)", display: "Certified Consumer Reviews (CCR)"},
  {value: "Google", display: "Google"},
]


// WEBPACK FOOTER //
// ./src/containers/Reviews/ReviewConstants.js